import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Router } from '@angular/router';

import { Observable } from 'rxjs/internal/Observable';
import { catchError, throwError } from 'rxjs';

import { EventCategory } from '@common/modules/core/services/track';

import { TrackService } from './../../core/services/track/track.service';

@Injectable()
export class GlobalHttpInterceptorService implements HttpInterceptor {
  constructor(public router: Router, private trackService: TrackService) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError(error => {
        const urlObject = new URL(error?.url);
        const url = `${urlObject.protocol}//${urlObject.host}${urlObject.pathname}`;
        let traceId = '';

        // use regex to grep the TraceId from the error message, here is how the error looks like:
        /**
         * {
         *  "ErrorType": "FILE_NOT_FOUND",
         *  "Message": "General error. Trace id: 'd66b2e30-0ef9-461e-bac0-f1a1a3fca69d'."
         *   }
         */
        try {
          traceId = error?.error?.Message?.match(/Trace id: '([a-z0-9-]+)'/i)?.[1];
        } catch (e) {}

        this.trackService.track('http.request.error', {
          category: EventCategory.HTTP,
          data: {
            status: error?.status,
            name: error?.name,
            method: req?.method,
            url,
            error: error?.error,
            traceId
          }
        });

        return throwError(() => error);
      })
    );
  }
}
